import React, { useEffect, useState } from 'react';
import {
  InputGroup,
  InputLeftElement,
  Input,
  Box,
} from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';

const SearchInput = ({ searchText, setSearchText }) => {
  const [inputValue, setInputValue] = useState(searchText);


  // Update internal inputValue if searchText changes
  useEffect(() => {
    setInputValue(searchText);
  }, [searchText]);

  // Set data in setSearchText by debounce.
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      setSearchText(inputValue);
    }, 500);

    return () => clearTimeout(debounceTimer);
  }, [inputValue, setSearchText]);

  const handleSearchChange = (e) => {
    setInputValue(e.target.value);
  };

  return (
    <Box width="100%" display="flex" justifyContent="center" alignItems="center">
      <InputGroup>
        <InputLeftElement pointerEvents="none" h="full" display="flex" alignItems="center">
          <SearchIcon color="blue.400" boxSize={5} />
        </InputLeftElement>
        <Input
          type="text"
          placeholder="Search video"
          value={inputValue}
          onChange={handleSearchChange}
          bg="white"
          border="2px solid"
          borderColor="blue.400"
          h="50px"
          _hover={{ borderColor: "blue.400"}}
          _focus={{ borderColor: "blue.400", boxShadow: "0 0 0 1px #3182CE" }}
          borderRadius="xl"
        />
      </InputGroup>
    </Box>
  );
};

export default SearchInput;
